import React from "react";
import { Link } from "../router";

export default function PurchaseSuccessPage({ courseSlug }) {
  return (
    <div className="page page-narrow">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <div className="success-check">&#10003;</div>
        <h1>You're enrolled!</h1>
        <p className="muted">Your purchase was successful. You can start learning right away.</p>
        <Link to={courseSlug ? `/learn/${courseSlug}` : "/dashboard"} className="btn btn-primary btn-block">
          Go to course
        </Link>
      </div>
    </div>
  );
}
